export interface IsoCountry {
    name: string;
    alpha2: string;
}

export const toCountryIsoCodeMap = (
    countries: IsoCountry[]
): Map<string, string> => {
    const countryMap = new Map<string, string>();
    countries.forEach((c) => countryMap.set(c.name, c.alpha2));

    return countryMap;
};
